<template>
  <div class="relative">
    <div class="text-text-label text-xs w-full mb-3-5" v-show="!!label">{{ label }}</div>
    <div class="flex items-center">
      <div class="flex items-center justify-center bg-block w-12 h-12
                border border-border rounded-full
                transition duration-200 cursor-pointer
                text-icon hover:border-border-hover hover:text-icon-hover" @click="select = selected">
        <MKIcons :icon="selected" class="text-text-ternary text-2sm"/>
      </div>
      <div class="text-xs text-text-ternary ml-4">
        <slot>Выберите иконку для счета</slot>
      </div>
    </div>
    <div v-if="select"
         class="icon-picker-popup space-y-10"
         v-on-click-away="hidePopup">
      <div class="grid grid-cols-12" v-for="(group,i) in groups" :key="i">
        <div class="text-sm text-text font-semibold mb-4 col-span-12 lg:col-span-2 lg:pt-2 ">
          {{ $t(group.title) }}
        </div>
        <div class="grid grid-cols-12 lg:grid-cols-icon-picker col-gap-2 row-gap-4
                    col-span-12 lg:col-span-10">
          <div v-for="(icon,j) in group.icons" :key="j"
               class="icon-preview"
               :class="{'selected':icon === selected && group.title !== 'BANKS',
                        'selected-bank':icon === selected && group.title === 'BANKS',
                        'p-3-3':group.title !== 'BANKS'}"
               @click="selectIcon(icon)">
            <MKIcons :icon="icon" class="flex items-center justify-center text-2sm"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {directive as onClickAway} from "vue-clickaway";
import {groups} from "@/components/icons/MKIcons/icons";
import MKIcons from "@/components/icons/MKIcons/MKIcons";

export default {
  name: "IconPicker",
  components: {
    MKIcons,
  },
  directives: {
    onClickAway: onClickAway
  },
  props: {
    selected: {
      //should be valid to one icons in data ALWAYS
      // required:true,
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      select: null,
      groups,
    }
  },
  methods: {
    selectIcon(icon) {
      this.$emit('change', icon);
      this.select = null;
    },
    hidePopup() {
      this.select = null
    }
  },
  i18n: {
    messages: {
      en: {
        'MONEY': 'Money',
        'BANKS': 'Banks',
        'SHOPPING': 'Shopping',
        'ALERTS': 'Alerts',
        'HOME & FAMILY': 'Home & family',
        'BUILDINGS': 'Buildings',
        'HOBBY & FUN': 'Hobby & fun',
        'OFFICE': 'Office',
        'TRANSPORT': 'Transport',
        'AUDIO / VIDEO': 'Audio / Video',
      },
      ru: {
        'MONEY': 'Деньги',
        'BANKS': 'Банки',
        'SHOPPING': 'Покупки',
        'ALERTS': 'Оповещения',
        'HOME & FAMILY': 'Дом и семья',
        'BUILDINGS': 'Строения',
        'HOBBY & FUN': 'Развлечения',
        'OFFICE': 'Офис',
        'TRANSPORT': 'Транспорт',
        'AUDIO / VIDEO': 'Аудио / видео',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.icon-picker-popup {
  @apply absolute mt-4 -bottom-4 -left-2 transform translate-y-full z-100 bg-block shadow-primaryBlock rounded p-4 ;
  width: 360px;
  @media (min-width: 1230px) {
    width: 721px;
  }
}

.icon-preview {
  @apply flex items-center justify-center cursor-pointer relative
  rounded-full text-white bg-text-ternary
  transition duration-200;
  width: 2.4rem;
  height: 2.4rem;

  &:before {
    @apply absolute transition duration-200 rounded-full border border-transparent;
    content: '';
    width: calc(100% + 4px);
    height: calc(100% + 4px);
  }

  &:hover {
    @apply bg-red;
    &:before {
      @apply border-red;
    }
  }

  &.selected {
    @apply bg-red;
  }

  &.selected-bank:before {
    @apply border-red;
  }
}
</style>